var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_widget"},[_c('img',{staticClass:"header_widget-logo",attrs:{"src":_vm.image_source}}),_c('p',{staticClass:"header_widget-retailer"},[_vm._v(_vm._s(_vm.retailer_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }